import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { router } from "./router";
import { ToastProvider, PWAInstallPrompt } from "./components";
import { AuthProvider } from "./contexts";
import { AnalyticsProvider } from "@jumpbean/analytics/react";
import { analyticsConfig } from "./lib/analytics";

/**
 * App - Root application component.
 *
 * Sets up:
 * - HelmetProvider for SEO meta tags
 * - Analytics provider for PostHog tracking
 * - Auth provider for authentication state
 * - React Router for navigation
 * - Toast provider for notifications
 * - PWA install prompt for app installation
 */
export function App() {
  return (
    <HelmetProvider>
      <AnalyticsProvider config={analyticsConfig}>
        <AuthProvider>
          <ToastProvider>
            <RouterProvider router={router} />
            <PWAInstallPrompt />
          </ToastProvider>
        </AuthProvider>
      </AnalyticsProvider>
    </HelmetProvider>
  );
}

export default App;
